
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/products?${queryString}`);
    return response.data;
  },
  async getStatics(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/products?${queryString}`);
    return response.data;
  },
  async getById(id) {
    const response = await https.get(`/products/${id}`);
    return response.data.data;
  },
  async getMailById(id) {
    const response = await https.get(`/products/${id}`);
    return response.data;
  },
  async getPdfById(id) {
    const response = await https.get(`/products/${id}`);
    return response.data;
  },
  async add(payload) {
    // Check if payload is FormData (for file uploads)
    if (payload instanceof FormData) {
      const response = await https.post(`/products`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      // For JSON payloads
      const response = await https.post(`/products`, payload);
      return response.data;
    }
  },

  async update(id, payload) {
    // Check if payload is FormData (for file uploads)
    if (payload instanceof FormData) {
      const response = await https.post(`/products/${id}`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      // For JSON payloads, use PUT
      const response = await https.post(`/products/${id}`, payload);
      return response.data;
    }
  },
  async deleteById(id) {
    const response = await https.delete(`/products/${id}`);
    return response.data;
  },
  async clone(id) {
    const response = await https.post(`/products/${id}/clone`);
    return response.data;
  },
  /**
   * Import products.
   *
   * Called twice for a file that references parts which do not exist yet:
   * first without options (the server refuses and returns
   * `missing_parts_summary`), then again with `confirmMissingParts: true` and
   * `createParts` holding only the parts the user ticked. Anything left
   * unticked stays missing, and the rows using it are skipped server-side
   * rather than imported with the BOM link silently absent.
   *
   * @param {File}   file
   * @param {object} [options]
   * @param {boolean} [options.confirmMissingParts]
   * @param {Array<{sub_type: string, name: string}>} [options.createParts]
   */
  async import(file, options = {}) {
    const formData = new FormData();
    formData.append('excel_file', file);

    if (options.confirmMissingParts) {
      formData.append('confirm_missing_parts', '1');
      (options.createParts || []).forEach((part, i) => {
        formData.append(`create_parts[${i}][sub_type]`, part.sub_type);
        formData.append(`create_parts[${i}][name]`, part.name);
      });
    }

    const response = await https.post(`/products/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async exportProduct(payload) {
    const response = await https.post('/products/export', payload);
    return response;
  },
});
